<!-- <template>
  <div class="search-result-item">
    <div class="result-meta">
      <span class="result-id"># {{ data._source.repertoire_id.slice(0, 8) }}...</span>
      <span class="study-link" v-if="data._source.study.study_id">
        {{ data._source.study.study_id }}
      </span>
      <div class="top-tags">
        <span class="tag-blue" v-if="data._source.sample[0]?.sequencing_platform">
          {{ data._source.sample[0].sequencing_platform }}
        </span>
        <span class="tag-blue" v-if="data._source.sample[0]?.library_generation_method">
          {{ data._source.sample[0].library_generation_method }}
        </span>
      </div>
    </div>

    <h3 class="result-title" @click="handleDetail">
      <span class="highlight-title" v-if="data.highlight?.repertoire_name"
        v-html="data.highlight.repertoire_name[0]"></span>
      <span v-else>{{ data._source.repertoire_name }}</span>
      <span class="title-sub-text">| {{ data._source.study.study_title }}</span>
    </h3>

    <div class="info-line">
      <span class="info-label">Species:</span>
      <span class="info-val">{{ data._source.subject.species.label }} ({{ data._source.subject.sex }})</span>
      <span class="info-label">Tissue:</span>
      <span class="info-val">{{ data._source.sample[0]?.tissue.label }}</span>
      <span class="info-label">Cell Subset:</span>
      <span class="info-val">{{ data._source.sample[0]?.cell_subset.label }}</span>
    </div>

    <p class="result-snippet">
      {{ data._source.study.study_description }}
    </p>

    <div class="result-footer-stats">
      <div class="stat-item">
        <span class="stat-num">{{ formatNumber(data._source.ir_sequence_count) }}</span>
        <span class="stat-unit">SEQUENCES</span>
      </div>
      <div class="stat-item">
        <span class="stat-num">{{ data._source.sample[0]?.sequencing_files.read_length || '--' }}bp</span>
        <span class="stat-unit">READ LENGTH</span>
      </div>
      <div class="stat-item">
        <span class="info-label">Locus:</span>
        <span class="locus-box">{{ data._source.sample[0]?.pcr_target[0]?.pcr_target_locus }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: { type: Object, required: true }
  });

  const formatNumber = (num) => {
    if (!num) return '0';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleDetail = () => {
    console.log('查看详情:', props.data._id);
  };
</script>

<style scoped>
  /* 容器去掉边框和背景，改用下划线分割 */
  .search-result-item {
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #f0f0f0;
    background: transparent;
    text-align: left;
  }

  .result-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .result-id {
    color: #70757a;
  }

  .study-link {
    color: #1a73e8;
    font-weight: 500;
  }

  .study-link::before {
    content: "›";
    margin-right: 8px;
    color: #70757a;
  }

  .top-tags {
    margin-left: auto;
    display: flex;
    gap: 8px;
  }

  /* 蓝色小标签样式，参考图2 */
  .tag-blue {
    background: #e8f0fe;
    color: #1967d2;
    padding: 1px 8px;
    border-radius: 4px;
    font-size: 11px;
  }

  /* 标题样式：加粗深蓝 */
  .result-title {
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: 700;
    color: #1a0dab;
    cursor: pointer;
    line-height: 1.3;
  }

  .title-sub-text {
    font-weight: 400;
    color: #4d5156;
    margin-left: 8px;
    font-size: 15px;
  }

  /* 属性行样式 */
  .info-line {
    font-size: 14px;
    margin-bottom: 8px;
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }

  .info-label {
    color: #70757a;
  }

  .info-val {
    color: #202124;
  }

  /* 描述文本 */
  .result-snippet {
    font-size: 14px;
    color: #5f6368;
    line-height: 1.6;
    margin: 8px 0 16px 0;
  }

  /* 底部统计栏 */
  .result-footer-stats {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
  }

  .stat-num {
    font-size: 18px;
    font-weight: 700;
    color: #202124;
  }

  .stat-unit {
    font-size: 11px;
    color: #70757a;
    margin-top: 2px;
  }

  .locus-box {
    background: #f1f3f4;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 13px;
    color: #202124;
  }

  /* 高亮样式 */
  :deep(em) {
    font-style: normal;
    color: #1a0dab;
    text-decoration: underline;
  }
</style> -->




<template>
  <div class="search-result-item">
    <div class="result-meta">
      <span class="study-id">{{ data._source.study.study_id }}</span>
      <span class="study-author" v-if="data._source.study.study_title">
        {{ data._source.study.study_title.split('.')[0] }}...
      </span>
      <div class="top-tags">
        <span class="tag-blue">Sample: {{ data._source.sample[0]?.sample_id }}</span>
      </div>
    </div>

    <h3 class="result-title" @click="handleDetail">
      <span v-if="data.highlight?.repertoire_name" v-html="data.highlight.repertoire_name[0]"></span>
      <span v-else>{{ data._source.repertoire_name }}</span>
    </h3>

    <div class="info-line">
      <div class="info-group">
        <span class="info-label">Subject ID:</span>
        <span class="info-val">{{ data._source.subject.subject_id || '--' }}</span>
      </div>
      <div class="info-group">
        <span class="info-label">Diagnosis:</span>
        <span class="info-val">{{ getDiagnosis }}</span>
      </div>
      <div class="info-group">
        <span class="info-label">Tissue:</span>
        <span class="info-val">{{ data._source.sample[0]?.tissue.label || '--' }}</span>
      </div>
      <div class="info-group">
        <span class="info-label">Cell Subset:</span>
        <span class="info-val">{{ data._source.sample[0]?.cell_subset.label || '--' }}</span>
      </div>
    </div>

    <div class="result-footer-stats">
      <div class="stat-item">
        <span class="stat-num">{{ formatNumber(data._source.ir_sequence_count) }}</span>
        <span class="stat-unit">SEQUENCES</span>
      </div>
      <div class="stat-item">
        <span class="locus-badge">
          {{ data._source.sample[0]?.pcr_target[0]?.pcr_target_locus || 'N/A' }}
        </span>
        <span class="stat-unit">PCR TARGET</span>
      </div>
      <div class="stat-item" v-if="data._source.sample[0]?.library_generation_method">
        <span class="method-text">{{ data._source.sample[0].library_generation_method }}</span>
        <span class="stat-unit">METHOD</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  const router = useRouter();

  const props = defineProps({
    data: { type: Object, required: true }
  });

  // 处理诊断信息的显示逻辑
  const getDiagnosis = computed(() => {
    const diag = props.data._source.subject.diagnosis?.[0]?.disease_diagnosis;
    return diag?.label || 'Healthy/Unknown';
  });

  const formatNumber = (num) => {
    if (!num) return '0';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleDetail = () => {
    console.log('查看库详情:', props.data._id);

    router.push({
      path: '/ireceptor',
      query: { database_name: props.data._index, id: props.data._id }
    });
  };
</script>

<style scoped>
  .search-result-item {
    width: 100%;
    padding: 16px 0;
    /* border-bottom: 1px solid #f0f0f0; */
    background: transparent;
    text-align: left;
  }

  .search-result-item:hover .result-title {
    text-decoration: underline;
  }

  .result-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    margin-bottom: 6px;
  }

  .study-id {
    color: #1a73e8;
    font-weight: 600;
  }

  .study-author {
    color: #70757a;
  }

  .study-author::before {
    content: "›";
    margin-right: 8px;
  }

  .top-tags {
    margin-left: auto;
  }

  .tag-blue {
    background: #f8f9fa;
    border: 1px solid #dadce0;
    color: #3c4043;
    padding: 1px 6px;
    border-radius: 4px;
    font-size: 11px;
  }

  /* .result-title {
    margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a0dab;
    cursor: pointer;
  } */

  .result-title {
    margin: 0 0 4px 0;
    font-size: 20px;
    font-weight: 400;
    color: #1a0dab;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    gap: 10px;
    font-weight: 600;
  }

  /* 属性行：更紧凑的排版 */
  .info-line {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }

  .info-group {
    display: flex;
    gap: 6px;
    font-size: 13px;
  }

  .info-label {
    color: #70757a;
  }

  .info-val {
    color: #202124;
    font-weight: 500;
  }

  /* 底部统计指标 */
  .result-footer-stats {
    display: flex;
    gap: 40px;
    align-items: flex-end;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
  }

  .stat-num {
    font-size: 18px;
    font-weight: 700;
    color: #202124;
    line-height: 1;
  }

  .locus-badge {
    font-size: 14px;
    font-weight: 700;
    background: #e8f0fe;
    color: #1967d2;
    padding: 2px 8px;
    border-radius: 4px;
    width: fit-content;
  }

  .method-text {
    font-size: 14px;
    color: #202124;
    font-weight: 500;
  }

  .stat-unit {
    font-size: 10px;
    color: #9aa0a6;
    margin-top: 4px;
    letter-spacing: 0.5px;
  }

  :deep(em) {
    font-style: normal;
    color: #d93025;
    font-weight: bold;
  }
</style>